import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand } from "@/components/ui-bits/Primitives";
import { TrendingUp, Target, MapPin, Building2, Zap } from "lucide-react";
import { IMAGES } from "@/lib/site-data";

export default function Investors() {
    return (
        <div data-testid="investors-page">
            <PageHero
                kicker="Investor Relations"
                title="Building the public charging utility for Texas."
                lead="A veteran-owned platform combining grant-backed capital efficiency, vendor-neutral hardware, and 10-year operating economics."
                image={IMAGES.cityNight}
            />

            <Section>
                <Container>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        {[
                            { icon: TrendingUp, k: "Growth Projections", v: "10-Year Horizon", body: "Multi-year DC fast and Level 2 deployment plan across Texas and adjacent states, with structured P3 and grant-funded expansion." },
                            { icon: Target, k: "Market Opportunity", v: "$7B+ Texas TAM", body: "Texas commercial, fleet, multifamily and municipal charging market underserved relative to vehicle adoption curve." },
                            { icon: MapPin, k: "Expansion Strategy", v: "Texas-First, National-Ready", body: "Anchor sites in DFW, Houston, Austin, San Antonio — then corridor and rural expansion via NEVI and federal programs." },
                        ].map((b) => {
                            const I = b.icon;
                            return (
                                <Card key={b.k}>
                                    <I className="w-8 h-8 text-electric-400 mb-6" strokeWidth={1.5} />
                                    <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500">{b.k}</div>
                                    <div className="font-heading text-2xl text-white mt-1">{b.v}</div>
                                    <p className="mt-4 text-sm text-slate-400 leading-relaxed">{b.body}</p>
                                </Card>
                            );
                        })}
                    </div>

                    <div className="mt-16 border border-white/10 p-8 md:p-12 bg-ink-700/40">
                        <Eyebrow className="mb-4">Investment Thesis</Eyebrow>
                        <h2 className="font-heading text-3xl md:text-4xl text-white tracking-tight leading-tight max-w-3xl">Capital-efficient, grant-backed, infrastructure-grade.</h2>
                        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                            {[
                                { icon: Zap, t: "Grant-Backed Capex", b: "NEVI, TCEQ, NCTCOG and federal programs fund 50-80% of qualifying deployments." },
                                { icon: Building2, t: "P3 & Host Models", b: "Structured public-private partnerships and revenue-share agreements protect downside." },
                                { icon: TrendingUp, t: "Recurring Revenue", b: "Energy throughput, host fees, ad revenue, and demand-response — multiple revenue streams per site." },
                            ].map((x) => {
                                const I = x.icon;
                                return (
                                    <div key={x.t} className="border-l border-electric-400/40 pl-5">
                                        <I className="w-6 h-6 text-electric-400 mb-3" strokeWidth={1.5} />
                                        <div className="font-heading text-lg text-white">{x.t}</div>
                                        <p className="mt-2 text-sm text-slate-400">{x.b}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Container>
            </Section>

            <CTABand title="Want the full investor deck?" subtitle="Request the M-Class EV Charging information package." primaryLabel="Request Deck" />
        </div>
    );
}
